import isWithinInterval from "date-fns/isWithinInterval";
import { useCallback } from "react";

import { getSettingFreeDutiesPromoTimeRange } from "@faire/retailer/settings/getSettingFreeDutiesPromoTimeRange";

export const useImportDuties = () => {
  const hasFreeDuties = useCallback((): boolean => {
    return isWithinInterval(Date.now(), {
      start:
        (getSettingFreeDutiesPromoTimeRange().start_at?.seconds ?? 0) * 1000,
      end: (getSettingFreeDutiesPromoTimeRange().end_at?.seconds ?? 0) * 1000,
    });
  }, []);

  return {
    hasFreeDuties,
  };
};
